import { createApp } from "vue";

import VueMask from "vue-the-mask";
import YmapPlugin from "vue-yandex-maps";
import VueLazyLoad from "vue3-lazyload";

import {
    CasesMap,
    CasesPageContent,
    Finder,
    HeaderSlider,
    Icon,
    MainMenuSlider,
    MaterialOffers,
    PopupForm,
    RegionChanger,
    RegionPresentor,
    Seo,
    Slider,
} from "./vue";

const app = createApp({
    components: {
        vueIcon: Icon,
        vueFinder: Finder,
        vueSlider: Slider,
        vueCasesMap: CasesMap,
        vueHeaderSlider: HeaderSlider,
        vueRegionChanger: RegionChanger,
        vueMainMenuSlider: MainMenuSlider,
        vueMaterialOffers: MaterialOffers,
        vueRegionPresentor: RegionPresentor,
        vueCasesPageContent: CasesPageContent,
        vuePopupForm: PopupForm,
        vueSeo: Seo,
    },
});

app.use(YmapPlugin);
app.use(VueLazyLoad, {
    observerOptions: { rootMargin: "0px", threshold: 0.0 },
});
app.use(VueMask);

app.mount("#vue-app-container");
